<script lang="ts">
    // your script goes here
</script>


<div class="input-group">
   <slot></slot>
</div>

<style>
    .input-group {
        display: flex;
        flex-direction: row;
        border: 1px solid #ccc;
        padding: 8px 10px;
        border-radius: 8px;
        margin-top: 15px;
    }

    .input-group :global(input) {
        flex-grow: 2;
        border: none;
        font-size: 16px;
    }

    .input-group :global(input:focus) {
        outline: none;
    }

    .input-group :global(textarea) {
        width: 100%;
        height:max-content;
        font-size: 16px;
        border: none;

    }


</style>

